import {
  ACTION_INIT_TANSA,
  tansaLoadSuccess,
  getTansaInitializedOrFailed,
  tansaLoadError,
} from '~/redux/tansaReducer'
import { getTansaSettings } from '~/redux/settingsReducer'
import { Observable } from 'rxjs'
import CONSTANTS from '~/constants'
import intl from 'react-intl-universal'

export function getUserId(tansaSettings, primaryWebsiteUserId) {
  return (
    primaryWebsiteUserId ||
    tansaSettings.globalUserId ||
    window.localStorage.getItem('arc.email') ||
    'ellipsis@washpost.com'
  )
}

export const _getTansaSettings = (tansaSettings, primaryWebsiteUserId) => {
  return {
    settings: {
      licenseKey: tansaSettings.companyId,
      // For debugging. Can be any string, but recommended to keep it in line with the actual version of Composer.
      parentAppVersion: `${process.env.COMPOSER_VERSION}`,
      // Use user email or for debugging purposes, the ellipsis tansa account ( this is separate from the support system )
      // Your Account Credentials are as follows:
      // Username required for login is : ellipsis@washpost.com
      // Password : rj3re6zm
      userId: getUserId(tansaSettings, primaryWebsiteUserId),
      // Static across customers, provided for Composer
      parentAppId: '1d824302-9618-4260-bead-f65cdb0aa07a',
      // tansa server base urls, varies by customer. Some clients remain on the Arc server.
      baseUrl: tansaSettings.clientUrl || 'https://arc.tansa.com/tansaclient/',
      clientExtenstionJs: 'tansa4ClientExtensionSimple.js',
    },
  }
}

const tansaIntegrationEpic = (action$, store) =>
  action$
    .ofType(ACTION_INIT_TANSA)
    .filter(() => {
      const attempted = getTansaInitializedOrFailed(store.getState())
      return !attempted
    })
    .map((action) => {
      const { payload: primaryWebsiteUserId } = action

      const tansaSettings = getTansaSettings(store.getState())
      if (!tansaSettings.companyId) {
        return tansaLoadError(
          new Error(intl.get('epics.tansaIntegrationEpic.errors.configure'))
        )
      }
      const globalTansaSettings = _getTansaSettings(
        tansaSettings,
        primaryWebsiteUserId
      )
      global.tansa = globalTansaSettings
      return globalTansaSettings
    })
    .mergeMap((globalTansaSettings) => {
      const tansaLoaderScript = document.getElementById('tansaLoaderScript')
      if (tansaLoaderScript) {
        return Observable.of(
          tansaLoadError(
            new Error(
              intl.get('epics.tansaIntegrationEpic.errors.alreadyInitialized')
            )
          )
        )
      }
      const tansaPromise = new Promise((resolve, reject) => {
        try {
          const script = document.createElement('script')
          script.src = `${
            globalTansaSettings.settings.baseUrl
          }initTansaLoader.js?${new Date().getTime()}`
          document.querySelector('head').appendChild(script)
          script.onload = () => {
            resolve(tansaLoadSuccess())
          }
          script.onerror = () => {
            resolve(
              tansaLoadError(
                new Error(
                  intl.get('epics.tansaIntegrationEpic.errors.scriptError', {
                    msg: intl.get(
                      'epics.tansaIntegrationEpic.errors.appendError'
                    ),
                  })
                )
              )
            )
          }
        } catch (error) {
          resolve(
            tansaLoadError(
              new Error(
                intl.get('epics.tansaIntegrationEpic.errors.scriptError', {
                  msg: error.message,
                })
              )
            )
          )
        }
      })
      return Observable.fromPromise(tansaPromise)
    })
    .filter((action) => !!action)

export default tansaIntegrationEpic
